import { Injectable } from '@angular/core';
import { BehaviorSubject, from, map, Observable, switchMap, tap } from 'rxjs';
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { IAuthState } from './auth.service.interface';
import { AuthBaseService } from './auth-base.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends AuthBaseService {

  /**
   *
   */
  constructor(private fireAuth: AngularFireAuth, private fireStore: AngularFirestore) {
    super();
    this.authInit();
  }

  /**
   * 
   */
   private authInit() {
    this._authState = new BehaviorSubject<IAuthState>({ workingText: 'Initializing...', isLoggedIn: false, navLinks: [] });
    this.fireAuth.onAuthStateChanged((user) => {
      if (user) {
        this.signInImpl(user.uid, user.email, user.displayName || user.email);
      } else {
        this.signOutImpl();
      }
    });

  }

  /**
   * 
   * @param email 
   * @param password 
   * @param displayName
   * @returns 
   */
  register(email: string, password: string, displayName: string): Observable<void> {
    return from(this.fireAuth.createUserWithEmailAndPassword(email, password)).pipe(
      map(cred => cred.user.updateProfile({ displayName: displayName })),
      switchMap(() => this.signIn(email, password))
    );
  }

  /**
   * 
   * @param password 
   * @returns 
   */
  changePassword(password: string): Observable<void> {
    return from(this.fireAuth.currentUser).pipe(
      switchMap(user => from(user.updatePassword(password)))
    );
  }

  /**
   * 
   * @param email 
   * @returns 
   */
  resetPassword(email: string): Observable<void> {
    return from(this.fireAuth.sendPasswordResetEmail(email));
  }

  /**
   * 
   * @param email 
   * @param password 
   */
  signIn(email: string, password: string): Observable<void> {
    return from(this.fireAuth.signInWithEmailAndPassword(email, password)).pipe(
      map(cred => this.signInImpl(cred.user.uid, cred.user.email, cred.user.displayName ?? cred.user.email))
    );
  }

  /**
   * 
   * @returns 
   */
   signOut(): Observable<void> {
    return from(this.fireAuth.signOut()).pipe(
      tap(() => this.signOutImpl())
    );
  }  

}
